import { actions, KeyMap, MessageBox } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { defineMessages, useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import { DictionaryEffectType } from '../../../store/slices/dictionary';
import CategoryContainer from '../category/CategoryContainer';

import { DictionaryDialogContainerProps } from './DictionaryDialogContainer';

interface Props extends DictionaryDialogContainerProps {
  open: boolean;
}

const useStyles = createUseStyles({
  wrap: {
    composes: ['m-px-lg'],
    width: '100%',
    height: '100%',
  },
});

const messages = defineMessages({
  next: {
    id: 'core.dictionary.next',
    defaultMessage: 'Next',
  },
  close: {
    id: 'core.form.close',
    defaultMessage: 'Close',
  },
  save: {
    id: 'core.dictionary.save',
    defaultMessage: 'Save',
  },
});

const DictionaryDialog: React.FC<Props> = ({
  categoryId,
  open,
  title,
  outputsReady,
  nextAction,
  onConfirm,
  onCancel,
  effect,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  const save = intl.formatMessage(messages.save);
  const next = intl.formatMessage(messages.next);
  const close = intl.formatMessage(messages.close);

  const hotkeysRef = useHotkeys<HTMLDivElement>(
    KeyMap[actions.SUBMIT],
    onConfirm,
    { enableOnFormTags: ['INPUT', 'SELECT', 'TEXTAREA'] },
    [onConfirm]
  );

  return (
    <MessageBox
      open={open}
      title={title}
      onClose={onCancel}
      noCloseButton={false}
      width="90vw"
      height="90vh"
      resizable
    >
      <MessageBox.Content>
        <div className={classes.wrap} ref={hotkeysRef}>
          <CategoryContainer id={categoryId} showCommands />
        </div>
      </MessageBox.Content>
      <MessageBox.Footer>
        {!(
          effect === DictionaryEffectType.DO_NOTHING ||
          effect === DictionaryEffectType.REFRESH_ON_CLOSE
        ) && (
          <MessageBox.Button
            type="submit"
            onClick={onConfirm}
            disabled={!outputsReady}
            label={nextAction ? next : save}
          />
        )}
        <MessageBox.Button onClick={onCancel} label={close} />
      </MessageBox.Footer>
    </MessageBox>
  );
};

export default DictionaryDialog;
